<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Norm-Center" id="auto_bookmark_toc_3"><span>This book is dedicated to my husband, Andrew. I asked him to suggest a really big plot for book three. This is the result. Blame him, okay?</span></p>
<p class="P_Norm-Center"><span>But seriously… I couldn’t have written this without him.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?163454c0